import './mainCustomer.css';
import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import TokenError from '../tokenError';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Grid2, Typography, Avatar, IconButton, Paper, Grid, Snackbar, CircularProgress, Input } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import starIcon from '../../assets/icons/starIcon.png';
import { CSVLink } from "react-csv";
import axios from 'axios';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DatePicker } from '@mui/x-date-pickers';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { Dialog, DialogTitle, DialogContent, TextField,   Select,
    MenuItem,
    Box,
    FormControl} from '@mui/material';
import { Label } from 'flowbite-react';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import constants from '../../constant.js'

const Dashboard = () => {

    const serverUrl = config.serverUrl;
    const chatUrl = config.chatUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();

    const [rows, setRows] = useState([]);
    const [allData, setAllData] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [order, setOrder] = useState('ASC');
    const [orderBy, setOrderBy] = useState('user_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [customerId, setCustomerId] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const cities = JSON.parse(localStorage.getItem('cities'));
    
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const handleFilterChange = (filterType, value) => {    //handle the city filter
      if (filterType === 'city') setCityFilter(value);
    };

    const [open, setOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [type, setType] = useState('credit');

    const [newCustomerName, setNewCustomerName] = useState('');
    const [newCustomerPhone, setNewCustomerPhone] = useState('');
    const [newCustomerCountryCode, setNewCustomerCountryCode] = useState('');
    const [newCustomerEmail, setNewCustomerEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [newCustomerGender, setNewCustomerGender] = useState('');
    const [newCustomerDob, setNewCustomerDob] = useState(dayjs());
    const [newCustomerCompany, setNewCustomerCompany] = useState('');

    const [customerEditName,setCustomerEditName] = useState('');
    const [customerEditEmail,setCustomerEditEmail] = useState('');
    const [customerEditGender,setCustomerEditGender] = useState('');
    const [customerEditDob,setCustomerEditDob] = useState(dayjs());
    const [customerEditUserCode,setCustomerEditUserCode] = useState('');
    const [customerEditPhone,setCustomerEditPhone] = useState('');
    const [customerEditCountryCode,setCustomerEditCountryCode] = useState('');

    const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
    const [deactivateReason, setDeactivateReason] = useState('');
    const [actionType, setActionType] = useState('');  // 'deactivate' or 'delete'
    const [driverToAction, setDriverToAction] = useState(null);
    const [reasonError, setReasonError] = useState(false);
    const add_customer_enabled_for_panel = localStorage.getItem('add_customer_enabled_for_panel');
    const is_rizzo_client = localStorage.getItem('is_rizzo_client');
    const panel_customer_specific_address = localStorage.getItem('panel_customer_specific_address');
    const [startDateFilter, setStartDateFilter] = useState(dayjs());
    const [endDateFilter, setEndDateFilter] = useState();
    const [activationStatus , setActivationStatus] = useState('');
    const [activeStatusFilter , setActiveStatusFilter] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [designation, setDesignation] = useState('');
    const [maxRideLimit, setMaxRideLimit] = useState('');
    const [corporateRole, setCorporateRole] = useState('');
    const [maxBudgetLimit, setMaxBudgetLimit] = useState('');
    const [userCode, setUserCode] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [paginationInfo, setPaginationInfo] = useState({ total: 0, page_count: 1 });
    const [exportCsvData, setExportCsvData] = useState([]);
    const searchTimeoutRef = useRef(null);
    const csvLinkRef = useRef(null);
    const isInitialMount = useRef(true);
    const [exportloading,setExportloading] = useState(false);
    // const [rowsPerPage, setRowsPerPage] = useState(50);
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    const activation_deactivation_date_range = localStorage.getItem('activation_deactivation_date_range');
    const show_user_code_for_panel = localStorage.getItem('show_user_code_for_panel');
    const country_code = localStorage.getItem('default_country_iso_code' || 'IN');
    const [changedcountrycode,setChangedcountrycode] = useState(country_code);
    const today = dayjs().startOf('day');
    const clientId = localStorage.getItem('clientId');
    const [clientIdFilter, setClientIdFilter] = useState('');
    const [showExportDate, setShowExportDate] = useState(false);
    const [txnLoading, setTxnLoading] = useState(false);
    const [startDateFilterExportCSV, setStartDateFilterExportCSV] = useState(showExportDate ?  dayjs().startOf('month').startOf('day') : null);
    const [endDateFilterExportCSV, setEndDateFilterExportCSV] = useState(showExportDate ?  dayjs().endOf('month').startOf('day') : null);
    let permissions = [];
    const allowedTabsStr = JSON.parse(localStorage.getItem('clientRoleTabs')) || " ";
    const allowedTabs = allowedTabsStr?.split(',').map(Number);
    const SidebarTabs = constants.SidebarTabs;
    const hasPermission = (tabId) => allowedTabs.includes(tabId);
    const clientdataShown = localStorage.getItem('hideuserinfo');
    const admin_id = localStorage.getItem("admin_id");

    try {
        const stored = localStorage.getItem('clientTabPermission');
        if (stored && stored !== 'undefined') {
            permissions = JSON.parse(stored);
        }
        if (!Array.isArray(permissions)) {
            permissions = [];
        }
    } catch (error) {
        console.error("Error parsing clientTabPermission from localStorage:", error);
        permissions = [];
    }
    const clientDemoType = localStorage.getItem('clientDemoType');
    const clientRole = localStorage.getItem('clientRole');

    const handleOpen = (row) => {
        setSelectedRow(row);
        setType('credit'); // Reset to default when opening modal
        setAmount(''); // Clear amount
        setReason(''); // Clear reason
        setOpen(true);
    };

    const customerTab = permissions.find(p => p.tab_id === 1);

// Check if permission "1" exists
    const hasPermission1 = customerTab?.permissions?.split(',').includes("1");
    const hasPermission2 = customerTab?.permissions?.split(',').includes("2");
    const hasPermission3 = customerTab?.permissions?.split(',').includes("3");
    const hasPermission4 = customerTab?.permissions?.split(',').includes("4");

    const handleEditOpen = (row) =>{
        setSelectedRow(row);
        setEditOpen(true);
        setCustomerEditName(row.user_name);
        setCustomerEditEmail(row.user_email);
        setCustomerEditGender(row.gender);
        setCustomerEditCountryCode(row.country_code);
        console.log(row.phone_number)
        setCustomerEditPhone(row.phone_number);
        // setCustomerEditDob(dayjs(row.date_of_birth));
        if(row.date_of_birth && row.date_of_birth !== 'null'){
            setCustomerEditDob(dayjs(row.date_of_birth));
        } else{
            setCustomerEditDob(null);
        }

        setCustomerEditUserCode(row.user_code);
        
        // Properly handle activation date - parse if exists
        if (row.activation_date && row.activation_date !== 'null') {
            setStartDateFilter(dayjs(row.activation_date));
        } else {
            setStartDateFilter(null);
        }
        
        // Properly handle deactivation date - parse if exists
        if (row.deactivation_date && row.deactivation_date !== 'null') {
            setEndDateFilter(dayjs(row.deactivation_date));
        } else {
            setEndDateFilter(null);
        }
    }

    const headerCellStyle = {
        fontWeight: 600,
        fontSize: '0.875rem',
        color: '#374151',
        backgroundColor: '#f9fafb',
        padding: '12px 16px',
        borderBottom: '2px solid #e5e7eb',
        whiteSpace: 'nowrap',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        '&:hover': {
            backgroundColor: '#f3f4f6',
        },
        '& .MuiTableSortLabel-root': {
            color: 'inherit',
            '&:hover': {
            color: '#1d4ed8',
            },
            '&.Mui-active': {
            color: '#1d4ed8',
            '& .MuiTableSortLabel-icon': {
                color: '#1d4ed8',
            },
            },
        },
    };

    const headerLabelStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        paddingRight: '24px',
        color: 'inherit',
        // '&:hover': {
        //     color: '#1d4ed8',
        // },
    };
    const handleClose = () => {
        setOpen(false);
        setSelectedRow(null);
        setStartDateFilter(dayjs());
        setEndDateFilter();
        setActivationStatus('');
        setEmployeeId('');
        setDesignation('');
        setMaxRideLimit('');
        setCorporateRole('');
        setMaxBudgetLimit('');
    };

    const handleEditClose = () => {
        setEditOpen(false);
        setOpenEditModal(false);
        setSelectedRow(null);
        setStartDateFilter(dayjs());
        setEndDateFilter();
        setActivationStatus('');
        setEmployeeId('');
        setDesignation('');
        setMaxRideLimit('');
        setCorporateRole('');
        setMaxBudgetLimit('');
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        const previousId = customerId;
        setCustomerId(value);
        if (value.length === 0 && previousId.length > 0) {
            fetchData(1, rowsPerPage, '', customerPhone);
            return;
        }
    };

    const handleClientIdChange = (e) => {
        const value = e.target.value;
        const previousId = clientIdFilter;
        setClientIdFilter(value);
    
        // Clear any existing timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
    
        // If input is being cleared and we had a previous value
        if (value.length === 0 && previousId.length > 0) {
            fetchData(1, rowsPerPage, customerId, customerPhone, '');
            return;
        }
        
        // Only make API call if the input has 3 or more characters
        if (value.length >= 0) {
            searchTimeoutRef.current = setTimeout(() => {
                fetchData(1, rowsPerPage, customerId, customerPhone, value);
            }, 500);
        }
    };

    // const handlePhoneChange = (value) => {

    //     console.log(value,"value")
    //     // Value is either a string (e.g., "+919876543210") or undefined if cleared
    //     const previousPhone = customerPhone;
    //     const newValue = value || ''; // Handle undefined when input is cleared
    //     setCustomerPhone(newValue);
      
    //     // Parse phone number to get country code (optional, for logging or other use)
    //     let countryCode = '';
    //     // try {
    //     //   const parsed = parsePhoneNumber(newValue);
    //     //   if (parsed) {
    //     //     countryCode = parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '';
    //     //   }
    //     // } catch (err) {
    //     //   console.error('Invalid phone number:', err);
    //     // }
      
    //     // Clear any existing timeout
    //     if (searchTimeoutRef.current) {
    //       clearTimeout(searchTimeoutRef.current);
    //     }
      
    //     // If input is being cleared and we had a previous value
    //     if (newValue.length === 0 && previousPhone.length > 0) {
    //       fetchData(1, rowsPerPage, customerId, customerPhone,clientIdFilter);
    //       return;
    //     }
      
    //     // Only make API call if the input has 3 or more characters (including country code)
    //     if (newValue.length >= 6) {
    //       searchTimeoutRef.current = setTimeout(() => {
    //         fetchData(1, rowsPerPage, customerId, newValue,clientIdFilter);
    //       }, 500);
    //     }
    //   };

const handlePhoneFilterChange = (e) => {
    const value = e.target.value;
    const previousId = customerPhone;
    setCustomerPhone(value);

    // Clear any existing timeout
    if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
    }

    // If input is being cleared and we had a previous value
    if (value.length === 0 && previousId.length > 0) {
        fetchData(1, rowsPerPage, customerId, customerPhone, '');
        return;
    }
    
    // Only make API call if the input has 2 or more characters
    if (value.length >= 2) {
        searchTimeoutRef.current = setTimeout(() => {
            fetchData(1, rowsPerPage, customerId, customerPhone, value);
        }, 500);
    }
};
    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        let filtered = rows;
    
        // Filter by customerId
        // if (customerId) {
        //     filtered = filtered.filter(item =>
        //         item.user_id?.toString().includes(customerId)
        //     );
        // }
    
        // Filter by customerPhone
        // if (customerPhone) {
        //     filtered = filtered.filter(item =>
        //         item.phone_number?.toString().includes(customerPhone)
        //     );
        // }
    
        // Filter by activation status
        if (activeStatusFilter === "1") {
            // Activated
            filtered = filtered.filter(item =>
                item.deactivation_status == 1 || item.deactivation_status == 0
            );
        } else if (activeStatusFilter === "2" ) {
            // Deactivated
            filtered = filtered.filter(item =>
                item.deactivation_status == 2
            );
        }
        // "All" shows everyone (no filter)
    
        setFilteredRows(filtered);
        setPaginatedData(filtered);
        if (filtered.length !== filteredRows.length) {
            setPage(0);
            fetchData(1, rowsPerPage);
        }
        // setPage(0);
    }, [activeStatusFilter, rows,filteredRows.length]);

    const fetchData = async (page,page_size= rowsPerPage,customerId = '',customerPhone = '',clientIdFilter = '',fetchall = false,sortBy = orderBy,sortOrder = order) => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/fetch_all`;
            const obj={
                token,
                timestamp,
                ...(cityFilter && { city_id: cityFilter }),
            }
            if(sortBy){
                obj.column_name = sortBy;
            }
            if(sortOrder){
                obj.sort_order = sortOrder;
            }   
            if(startDateFilterExportCSV){
                obj.start_date = startDateFilterExportCSV.format('YYYY-MM-DD');
            }
            if(endDateFilterExportCSV){
                obj.end_date = endDateFilterExportCSV.format('YYYY-MM-DD');
            }
            if(page){
                obj.page = page;
            }
            if(page_size){
                obj.page_size = page_size;
            }
            if(customerId){
                obj.user_id = customerId;
            }
            if(customerPhone){
                obj.phone_number = customerPhone;
            }
            if(activeStatusFilter){
                obj.deactivation_status = activeStatusFilter;
            }
            if(clientIdFilter){
                obj.user_code = clientIdFilter;
            }
            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            
            if(response.flag === 200){
                const customersData = response.data;    
                setPaginationInfo({
                    total: response.pagination?.total || 0,
                    page_count: response.pagination?.page_count || 1,
                });
                setTotalPages(response.pagination?.page_count || 1);
                // Apply default sorting (descending by user_id)
                // const sortedData = [...customersData].sort((a, b) => {
                //     // Handle null or undefined values
                //     if (a.user_id == null) return 1;
                //     if (b.user_id == null) return -1;
                //     return b.user_id - a.user_id;
                // });
                if (fetchall) {
                    const formattedData = formatDataForCSV(customersData);
                    setExportCsvData(formattedData);
                    return formattedData;
                } else {
                    setRows(customersData);
                    setFilteredRows(customersData);
                    setPaginatedData(customersData);
                    const formattedData = formatDataForCSV(customersData);
                    setAllData(formattedData);
                    return formattedData;
                }
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setRows([]);
            setFilteredRows([]);
            return [];
        }
    };
    
    // Enhanced sorting function that handles different data types intelligently
    // const handleRequestSort = (property) => {
    // const isAscending = orderBy === property && order === 'asc';
    // const newOrder = isAscending ? 'desc' : 'asc';
    // setOrder(newOrder);
    // setOrderBy(property);
    
    // const sortedRows = [...filteredRows].sort((a, b) => {
    //     // Handle null or undefined values
    //     if (a[property] == null) return newOrder === 'asc' ? -1 : 1;
    //     if (b[property] == null) return newOrder === 'asc' ? 1 : -1;
        
    //     // Determine the data type and sort accordingly
    //     if (typeof a[property] === 'number') {
    //         // Numeric sorting
    //         return newOrder === 'asc' ? a[property] - b[property] : b[property] - a[property];
    //     } else if (typeof a[property] === 'string') {
    //         // String sorting (case-insensitive)
    //         const aValue = a[property].toLowerCase();
    //         const bValue = b[property].toLowerCase();
    //         if (aValue < bValue) return newOrder === 'asc' ? -1 : 1;
    //         if (aValue > bValue) return newOrder === 'asc' ? 1 : -1;
    //         return 0;
    //     } else if (a[property] instanceof Date) {
    //         // Date sorting
    //         return newOrder === 'asc' ? a[property] - b[property] : b[property] - a[property];
    //     } else {
    //         // Default comparison
    //         if (a[property] < b[property]) return newOrder === 'asc' ? -1 : 1;
    //         if (a[property] > b[property]) return newOrder === 'asc' ? 1 : -1;
    //         return 0;
    //     }
    //         });
            
    //         setFilteredRows(sortedRows);
    //     };

    const handleRequestSort = (column_name) => {
        const isAsc = orderBy === column_name && order === 'ASC';
        const newOrder = isAsc ? 'DESC' : 'ASC';
        setOrder(newOrder);
        setOrderBy(column_name);
        fetchData(1, rowsPerPage,"","","",false, column_name, newOrder);
    };
        const handleChangePage = (event, newPage) => {
            setPage(newPage);
            fetchData(newPage + 1, rowsPerPage,"","","",false,orderBy,order);
            navigate(`?page=${newPage + 1}`); // Update URL
        };

        const handleExportCSV = async () => {
            try {
                setExportloading(true);
                const data = await fetchData( customerId, customerPhone.length >= 2 ? customerPhone : '',);
                
                await new Promise(resolve => setTimeout(resolve, 1000));
                
                if (data && data.length > 0) {
                    setExportCsvData(data);
                    setShowExportDate(false);
                    setStartDateFilterExportCSV("");
                    setEndDateFilterExportCSV("");
                    setTimeout(() => {
                        if (csvLinkRef.current) {
                            csvLinkRef.current.link.click();
                        }
                    }, 500);
                }
            } catch (error) {
                console.error('Error exporting CSV:', error);
            } finally {
                setExportloading(false);
            }
        };


        useEffect(() => {
            if (isInitialMount.current) {
                const params = new URLSearchParams(window.location.search);
                const urlPage = parseInt(params.get('page') || '1', 10) - 1;
                setPage(urlPage);
                fetchData(urlPage + 1, rowsPerPage);
                isInitialMount.current = false;
            } else {
                fetchData(1, rowsPerPage); 
            }
        }, [cityFilter, rowsPerPage,endDateFilterExportCSV]); 


        useEffect(() => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }

            // Only trigger fetchData if customerId, activeStatusFilter, or customerPhone with 3+ digits is set
            if (customerId || (customerPhone && customerPhone.length >= 2) || activeStatusFilter) {
                searchTimeoutRef.current = setTimeout(() => {
                    fetchData(1, rowsPerPage, customerId, customerPhone.length >= 2 ? customerPhone : '');
                }, 500);
            }
        }, [customerId, customerPhone, activeStatusFilter, rowsPerPage]);



    const formatDataForCSV = (data) => {
        return data.map((item) => {
            // Apply phone number masking if needed
            let maskedPhoneNumber = item.phone_number;
            if (clientdataShown != 0 && item.phone_number) {
                const phone = item.phone_number;
                const cleanPhone = phone.replace(/\D/g, '');
                if (cleanPhone.length <= 4) {
                    maskedPhoneNumber = '****';
                } else {
                    const firstTwo = cleanPhone.substring(0, 2);
                    const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                    const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                    maskedPhoneNumber = "+" + firstTwo + maskedMiddle + lastTwo;
                }
            }

            // Apply email masking if needed
            let maskedEmail = item.user_email;
            if (clientdataShown != 0 && item.user_email) {
                const email = item.user_email;
                const atIndex = email.indexOf('@');
                if (atIndex <= 2) {
                    maskedEmail = '**' + email.substring(atIndex);
                } else {
                    const firstTwo = email.substring(0, 2);
                    const domain = email.substring(atIndex);
                    const maskedMiddle = '*'.repeat(atIndex - 2);
                    maskedEmail = firstTwo + maskedMiddle + domain;
                }
            }

            return {
                ...item,

                date_of_birth : item.date_of_birth?.split('T')[0],

                email_verification_status : item.email_verification_status==1 ? 'Verified' : 'Not Verified',
                gender : item.gender==1 ? 'Male' : item.gender==2 ? 'Female' : item.gender==3 ? 'Others' : 'Others',

                city_id : (clientCities.find(city => city.city_id === item.city_id)) ? (clientCities.find(city => city.city_id === item.city_id)).city_name : '--',
                registered_city_id: (clientCities.find(city => city.city_id === item.registered_city_id)) ? (clientCities.find(city => city.city_id === item.registered_city_id)).city_name : '--',
                device_type : item.device_type==0 ? 'Android' : item.device_type==1 ? 'iOS' : '--',

                // Apply masked values
                phone_number: maskedPhoneNumber,
                user_email: maskedEmail,
            };
        });
    };

     // Define custom headers
     const headers = [
        { label: 'Customer ID', key: 'user_id' },
        { label: 'Customer Name', key: 'user_name' },
        { label: 'Email', key: 'user_email' },
        { label: 'Phone Number', key: 'phone_number' },
        // { label: 'Customer Image', key: 'user_image' },
        { label: 'Email Varification Satus', key: 'email_verification_status' },
        { label: 'City', key: 'city_id' },
        { label: 'Registered City', key: 'registered_city_id' },
        { label: 'Gender', key: 'gender' },
        { label: 'Current Latitude', key: 'current_latitude' },
        { label: 'Current Longitude', key: 'current_longitude' },
        { label: 'Registered Latitude', key: 'registered_latitude' },
        { label: 'Registered Longitude', key: 'registered_longitude' },
        // { label: 'Date Of Birth', key: 'date_of_birth' },
        { label: 'Total Trips', key: 'total_trips' },
        { label: 'Rating', key: 'rating' },
        { label: 'User Wallet Balance', key: 'user_wallet_balance' },
        { label: 'Device Type', key: 'device_type' },
        { label: 'App Version Code', key: 'app_version_code' },
        { label: 'Created At', key: 'registered_date' }
        // { label: 'Deactivate / Delete', key: 'deactivate_delete' },
    ];

    const rizzoHeaders = [
        { label: 'Customer ID', key: 'user_id' },
        { label: 'Customer Name', key: 'user_name' },
        { label: 'Email', key: 'user_email' },
        { label: 'Phone Number', key: 'phone_number' },
        { label: 'Customer Image', key: 'user_image' },
        { label: 'Email Varification Satus', key: 'email_verification_status' },
        { label: 'City', key: 'city_id' },
        { label: 'Registered City', key: 'registered_city_id' },
        { label: 'Current Latitude', key: 'current_latitude' },
        { label: 'Current Longitude', key: 'current_longitude' },
        { label: 'Registered Latitude', key: 'registered_latitude' },
        { label: 'Registered Longitude', key: 'registered_longitude' },
        { label: 'Total Trips', key: 'total_trips' },
        { label: 'Rating', key: 'rating' },
        { label: 'User Wallet Balance', key: 'user_wallet_balance' },
        { label: 'Company Name', key: 'company_name' },
        { label: 'Created At', key: 'registered_date' }
    ]

    const jayaHeaders = [
        { label: 'Customer ID', key: 'user_id' },
        { label: 'Customer Name', key: 'user_name' },
        { label: 'Client ID', key: 'user_code' },

        { label: 'Email', key: 'user_email' },
        { label: 'Phone Number', key: 'phone_number' },
        { label: 'Customer Image', key: 'user_image' },
        { label: 'Email Varification Satus', key: 'email_verification_status' },
        { label: 'City', key: 'city_id' },
        { label: 'Registered City', key: 'registered_city_id' },
        { label: 'Gender', key: 'gender' },
        { label: 'Date Of Birth', key: 'date_of_birth' },
        { label: 'Total Trips', key: 'total_trips' },
        { label: 'Rating', key: 'rating' },
        { label: 'Created At', key: 'registered_date' }
        // { label: 'Deactivate / Delete', key: 'deactivate_delete' },
    ]

    const handleSubmit = async () => {
        if (!selectedRow) {
            console.log("No user selected for transaction");
            return;
        }
        setTxnLoading(true);
    
        try {
            const token = localStorage.getItem('token');

            // Map 'credit' to 1 and 'debit' to 2
            const txnType = type === "credit" ? 1 : 2;
    
            const params = {
                token,
                txn_type: txnType,
                amount,
                user_id: selectedRow.user_id,
                user_type: 0, // assuming customer
                reason,
                admin_id:admin_id
            };
    
            const response = await axios.post(`${serverUrl}/admin/wallet_transactions`, params);
            console.log(response,"resdf")
            if(response?.data?.flag == 200){
                showSnackbar(true);
                setMessage("Transaction Successfully");
                await fetchData(); // Re-fetch updated data
                handleClose();
            }else{
                showSnackbar(true);
                setMessage("Failed to make transaction");
            }
        } catch (error) {
            console.error('Error while submitting:', error.message);
        } finally {
          setTxnLoading(false);
        }
    };

    // useEffect(() => {
    //     const paginated = Array.isArray(filteredRows)
    //         ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    //         : [];
    //     setPaginatedData(paginated);
    // }, [filteredRows, page, rowsPerPage]);

    // Update paginated data when filtered rows or pagination changes
    // useEffect(() => {
    //     const startIndex = page * rowsPerPage;
    //     const endIndex = startIndex + rowsPerPage;
    //     const paginated = filteredRows.length > 0 
    //         ? filteredRows.slice(startIndex, endIndex)
    //         : [];
        
    //     setPaginatedData(paginated);
        
    //     // If we have filtered rows but no paginated data, reset to first page
    //     if (filteredRows.length > 0 && paginated.length === 0) {
    //         setPage(0);
    //         // Refetch data for first page
    //         fetchData(1, rowsPerPage, "", "", "", false, orderBy, order);
    //     }
    // }, [filteredRows, page, rowsPerPage]);
    
    const handleEditSubmit = async () => {
        if (!selectedRow) {
            console.log("No user selected for transaction");
            return;
        }
    
        try {
            const token = localStorage.getItem('token');    
            const params = {
                token,
                user_id: selectedRow.user_id,
                
                // activation_date : startDateFilter.format('YYYY-MM-DD'),
                // deactivation_date : endDateFilter.format('YYYY-MM-DD'),
                // deactivation_status : activationStatus,
                
            };
            if(clientRole != '2'){
                console.log('dob',customerEditDob)
                if(activation_deactivation_date_range==1){
                    if(endDateFilter && dayjs(selectedRow.deactivation_date)?.format('YYYY-MM-DD')!=endDateFilter?.format('YYYY-MM-DD')){
                        params.deactivation_date = endDateFilter?.format('YYYY-MM-DD');
                    }
                    if(startDateFilter && dayjs(selectedRow.activation_date)?.format('YYYY-MM-DD')!=startDateFilter?.format('YYYY-MM-DD')){
                        params.activation_date = startDateFilter?.format('YYYY-MM-DD');
                    }
                    const stat = activationStatus ? activationStatus : 1;
                    if(selectedRow.deactivation_status!=stat){
                        params.deactivation_status = stat;
                    }
                }
                if(selectedRow.user_name!=customerEditName){
                    params.user_name = customerEditName;
                }
                if(selectedRow.user_email!=customerEditEmail){
                    params.user_email = customerEditEmail;
                }
                if(selectedRow.gender!=customerEditGender){
                    params.gender = customerEditGender;
                }
                if(selectedRow.country_code!=customerEditCountryCode){
                    params.country_code = customerEditCountryCode;
                }
                if(selectedRow.phone_number!=customerEditPhone){
                    params.phone_number = customerEditPhone;
                }
                if(customerEditDob && customerEditDob.isValid() && dayjs(selectedRow.date_of_birth)?.format('YYYY-MM-DD')!=customerEditDob?.format('YYYY-MM-DD')){
                    console.log('dob-2',customerEditDob)
                    params.date_of_birth = customerEditDob?.format('YYYY-MM-DD');
                }
                if(show_user_code_for_panel==1 && selectedRow.user_code!=customerEditUserCode){
                    params.user_code = customerEditUserCode;
                }
            }
            if(clientRole == 2 ){
                params.user_name = newCustomerName;
                params.user_email = newCustomerEmail;
                params.corporate_emp_id = employeeId;
                params.corporate_designation = designation;
                // params.corporate_budget_limit = maxBudgetLimit;
                params.corporate_ride_limit = maxRideLimit;
                params.corporate_role = corporateRole;
            }
            const keys = Object.keys(params);
            if (keys.length === 2 && keys.includes('user_id') && keys.includes('token')) {
                setMessage('Nothing to update.');
                showSnackbar(true);
                // handleEditClose();
                setEditOpen(false);
                setOpenEditModal(false);
                setSelectedRow(null);
                return;
            }
    
            const url = operationsUrl + '/panel/update_customer';
            const response = await makePostRequestToUrl(url,params);
            if(response.flag === 200){
                setMessage(response.message)
                showSnackbar(true);
                fetchData(); // Re-fetch updated data
                handleEditClose();
            }
            else if(response.flag === 102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else{
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while submitting:', error.message);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleCloseModal = () => {
        setOpenAddModal(false);
        setOpenEditModal(false);
        setEmailError(false);
        setSelectedRow(null);
        setStartDateFilter(dayjs());
        setEndDateFilter();
        setActivationStatus('');
        setEmployeeId('');
        setDesignation('');
        setMaxRideLimit('');
        setCorporateRole('');
        setMaxBudgetLimit('');
    }
    const handleOpenDeactivateModal = (row, type) => {
        setDriverToAction(row);
        setActionType(type);
        setDeactivateReason('');
        setReasonError(false);
        setOpenDeactivateModal(true);
    };

    const handleCloseDeactivateModal = () => {
        setOpenDeactivateModal(false);
        setDriverToAction(null);
        setDeactivateReason('');
        setReasonError(false);
      };
      
      const handleReasonChange = (e) => {
        setDeactivateReason(e.target.value);
        if (e.target.value.trim() !== '') {
          setReasonError(false);
        }
      };      
      const handleConfirmDeactivate = () => {
        if (deactivateReason.trim() === '') {
          setReasonError(true);
          return;
        }
        
        // Map action types to their corresponding status codes
        let status;
        switch(actionType) {
          case 'activate':
            status = 1; // Activate status code
            break;
          case 'deactivate':
            status = 2; // Deactivate status code
            break;
          case 'delete':
            status = 3; // Delete status code
            break;
          default:
            status = 0;
        }
        
        // Call the existing deleteDeactivate function with the selected driver and status
        deleteDeactivate(driverToAction, status);
        handleCloseDeactivateModal();
        fetchData(); // Refresh data after action
      };


      const deleteDeactivate = async(row, status) => {
        const token = localStorage.getItem('token');
        const payload = {
          token: token,
          user_id: row.user_id,
          status: status,
          reason: deactivateReason // Use the reason from the modal input
        };
        
        try {
          const url = operationsUrl + '/panel/deactivate_customer';
          const response = await makePostRequestToUrl(url, payload);
          if (response.flag === 200) {
              setMessage(response.message)
              showSnackbar(true);
          } else {
              setMessage(response.message)
              showSnackbar(true);
          }
        } catch (error) {
          console.error('Error while deactivating:', error);
          setMessage(error);
        }
        
        fetchData(); // Refresh data to show updated status
      }
      const addNewCustomer = () => {
        setOpenAddModal(true);
        setNewCustomerName('');
        setNewCustomerEmail('');
        setNewCustomerPhone('');
        setNewCustomerCompany('');
        setNewCustomerCountryCode('');
        setNewCustomerGender('');
        setNewCustomerDob(dayjs());
        setEmployeeId('');
        setDesignation('');
        setMaxRideLimit('');
        setCorporateRole('');
        setMaxBudgetLimit('');
        setUserCode('');
    }

    const handleOpenEdit = (row) => {
        setOpenEditModal(true);
        setSelectedRow(row);
        setNewCustomerName(row.user_name);
        setNewCustomerEmail(row.user_email);
        setUserCode(row.user_code);
        setNewCustomerPhone(row.phone_number);
        setEmployeeId(row.corporate_emp_id);
        setDesignation(row.corporate_designation);
        setMaxRideLimit(row.corporate_ride_limit);
        setCorporateRole(row.corporate_role);
    }
    


    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
    };

    useEffect(() => {
        try {
            const todayStr = today?.format('YYYY-MM-DD');
            let startStr = null;
            let endStr = null;
            
            // Safely handle startDateFilter
            if (startDateFilter) {
                // Check if it's already a dayjs object
                if (typeof startDateFilter?.format === 'function') {
                    startStr = startDateFilter?.format('YYYY-MM-DD');
                } else {
                    // Otherwise try to parse it
                    startStr = dayjs(startDateFilter)?.format('YYYY-MM-DD');
                }
            }
            
            // Safely handle endDateFilter
            if (endDateFilter) {
                // Check if it's already a dayjs object
                if (typeof endDateFilter?.format === 'function') {
                    endStr = endDateFilter?.format('YYYY-MM-DD');
                } else {
                    // Otherwise try to parse it
                    endStr = dayjs(endDateFilter)?.format('YYYY-MM-DD');
                }
            }
            
            // Only check date range if both dates are valid
            if (startStr && endStr) {
                if (todayStr >= startStr && todayStr <= endStr) {
                    setActivationStatus(1);
                } else {
                    setActivationStatus(0);
                }
            }
        } catch (error) {
            console.error('Error processing dates:', error);
            // Default to inactive if there's an error
            setActivationStatus(0);
        }
    }, [startDateFilter, endDateFilter, today]);

    const saveNewCustomer = async () => {
        if (!validateEmail(newCustomerEmail)) {
            setEmailError(true);
            setMessage('Please enter a valid email address');
            showSnackbar(true);
            return;
        }
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const params = {
                token,
                city_id: cityFilter,
                country_code: newCustomerCountryCode,
                phone_number: newCustomerPhone,
                user_name: newCustomerName,
                user_email: newCustomerEmail,
                // activation_date : startDateFilter,
                // deactivation_date : endDateFilter,
                // deactivation_status : activationStatus,
                // gender: newCustomerGender,
                // date_of_birth: newCustomerDob.format('YYYY-MM-DD')
            };
            if(clientRole != '2'){
                params.activation_date = startDateFilter;
                params.deactivation_date = endDateFilter;
                params.deactivation_status = activationStatus ? activationStatus : 1;
            }
            if(clientRole == 2 ){
                params.corporate_emp_id = employeeId;
                params.corporate_designation = designation;
                // params.corporate_budget_limit = maxBudgetLimit;
                params.corporate_ride_limit = maxRideLimit;
                params.corporate_role = corporateRole;
            }
            if(is_rizzo_client!=1 && clientRole != '2' && newCustomerGender){
                params.gender = newCustomerGender
            }
            if(is_rizzo_client!=1 && clientRole != '2'){
                params.date_of_birth = newCustomerDob?.format('YYYY-MM-DD')
            }
            if(is_rizzo_client==1 && newCustomerCompany!=""){
                params.company_name = newCustomerCompany
            }
            if(userCode && show_user_code_for_panel==1){
                params.user_code = userCode
            }
            try {
                const url = operationsUrl + '/panel/add_new_customer';
                const response = await makePostRequestToUrl(url,params);
                if (response.flag === 200) {
                    setMessage(response.message)
                    showSnackbar(true);
                    handleCloseModal(); // Close the modal after saving
                    fetchData();
      
                } else {
                    setMessage(response.message)
                    showSnackbar(true);
                }
      
            } catch (error) {
                console.error('Error while adding:', error);
                setMessage(error);
            }
    
        } catch (error) {
            console.error('Error while submitting:', error.message);
        }
    };

    const fetchChatDetials = async(row)=>{
        try {
          const payload = {
            user_id : row.user_id,
            client_id : clientId
          }
          const url = chatUrl + '/chat/get_admin_user_conversations';
          const response = await makeGetRequestToUrl(url,payload);
          const chat_id = response.data.chat_id;
          if(response.flag === 200){
            navigate('/support-chat?chat_id=' + chat_id + '&user_type=' + 1 );
          }
        } catch (error) {
            console.error('Error while fetching chat details:', error);
        }
    }

    const viewData = (row) => {
        navigate('/customer-details', { state: { rowData: row, cityFilter: cityFilter } });
    };

    const chatClick = (row) => {
        fetchChatDetials(row);
    };

    return(
        <div>

        {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>User</Typography>
            <Typography style={{ color: '#83888E'}}>User / Customer</Typography>

            <Grid2 container spacing={2} direction="row" alignItems="center"  wrap="nowrap" style={{ marginTop: '2%', marginBottom: '2%' }}>
                <Grid2 sx={{marginRight:'1%'}}>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '200px',
                            height: '46px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        {clientRole == 1 && <MenuItem value="">All</MenuItem>}
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 xs="auto">
                    <input type="number" placeholder="Customer Id" className='filterBtn' value={customerId} onChange={handleInputChange} min="0"
                    onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                          e.preventDefault();
                        }
                    }}
                    style={{
                        width: '200px',
                        height: '46px',
                        borderRadius: '8px',
                        backgroundColor: customerId ? '#F9F9F9' : '#FFFFFF',
                    }}
                     />
                </Grid2>
                {clientId == 188 && <Grid2 xs="auto">
                    <input type="text" placeholder="Client Id" className='filterBtn' value={clientIdFilter} onChange={handleClientIdChange} min="0" style={{
                        width: '200px',
                        height: '46px',
                        borderRadius: '8px',
                        backgroundColor: clientIdFilter ? '#F9F9F9' : '#FFFFFF',
                    }}/>
                </Grid2>}

                <Grid2 xs="auto">
                    <input type="number" placeholder="Phone Number" className='filterBtn' value={customerPhone} onChange={handlePhoneFilterChange} min="0"
                    onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                          e.preventDefault();
                        }
                    }}
                    style={{
                        width: '200px',
                        height: '46px',
                        borderRadius: '8px',
                        backgroundColor: customerPhone ? '#F9F9F9' : '#FFFFFF',
                    }}
                     />
                </Grid2>

                {/* <Grid2 xs="auto" style={{marginLeft:'2%'}}>
                    <Button variant="contained" onClick={getFilteredData} style={{width: '170px', height: '44px', marginRight: '12px', backgroundColor: '#0065FF', textTransform:'none', borderRadius:'8px'}}> Apply Filter</Button>
                </Grid2> */}
                <Grid2 item>
                    <Select value={activeStatusFilter} 
                    onChange={(e) => setActiveStatusFilter(e.target.value)} displayEmpty
                    style={{width: '140px',height:'46px',borderRadius:'8px',backgroundColor: activeStatusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="" onClick={()=>fetchData(1,rowsPerPage)}>All</MenuItem>
                        <MenuItem value="1">Activated</MenuItem>
                        <MenuItem value="2">Deactivated</MenuItem>
                    </Select>
                </Grid2>
                {add_customer_enabled_for_panel==1 && hasPermission3 && (
                    <Grid2 xs="auto">
                        <Button variant='contained' style={{width: "140px",height: "44px",backgroundColor: "#000000",textTransform: "none",borderRadius: "8px"}}
                        onClick={addNewCustomer}>
                        Add Customer
                        </Button>
                    </Grid2>
                )}
            </Grid2>
            <Grid2 sx={{display:'flex', marginBottom: "2%"}} >
                    {!showExportDate && <Button
                        variant="contained"
                        style={{ 
                            width: '120px', 
                            height: '44px', 
                            backgroundColor: exportloading ? '#a0d8b3' : '#36C68F', 
                            textTransform: 'none', 
                            borderRadius: '8px',
                            marginLeft: "12px",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px'
                        }}
                        onClick={() => setShowExportDate(!showExportDate)}
                        disabled={exportloading}
                    >
                        {exportloading ? (
                            <>
                                <span style={{ color: '#fff' }}><CircularProgress size={20} style={{ color: '#fff' }} /></span>
                            </>
                        ) : (
                            <span style={{ color: '#fff' }}>Export CSV</span>
                        )}
                    </Button>}
                    <CSVLink
                        data={exportCsvData}
                        headers={is_rizzo_client == 1 ? rizzoHeaders : clientId == 188 ? jayaHeaders : headers}
                        filename={"Customer Data.csv"}
                        style={{ display: 'none' }}
                        ref={csvLinkRef}
                        target="_blank"
                        asyncOnClick={true}
                    />
                        {showExportDate && (
                        <Grid2 item sx={{ mt: -2.2, ml: 1 }}>
                            <Label>Start Date:</Label><br/>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    slotProps={{ 
                                        textField: { 
                                            size: 'small',
                                            error: endDateFilterExportCSV && startDateFilterExportCSV && startDateFilterExportCSV.isAfter(endDateFilterExportCSV)
                                        } 
                                    }}
                                    sx={{
                                        width: '170px',
                                        '& .MuiInputBase-root': {
                                            minHeight: '44px',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                            minWidth:'150px',
                                        }
                                    }}
                                    value={startDateFilterExportCSV ? dayjs(startDateFilterExportCSV) : null}
                                    format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                                    onChange={(newValue) => {
                                        setStartDateFilterExportCSV(newValue);
                                    }}
                                    maxDate={endDateFilterExportCSV || undefined}
                                />
                            </LocalizationProvider>
                        </Grid2>)}
                        
                         {showExportDate && (
                        <Grid2 item sx={{ mt: -2.2 }}>
                            <Label>End Date:</Label><br/>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                                    slotProps={{ 
                                        textField: { 
                                            size: 'small',
                                            error: endDateFilterExportCSV && startDateFilterExportCSV && startDateFilterExportCSV.isAfter(endDateFilterExportCSV)
                                        } 
                                    }}
                                    sx={{
                                        width: '180px',
                                        '& .MuiInputBase-root': {
                                            minHeight: '44px',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                            minWidth:'150px'
                                        }
                                    }}
                                    disabled={!startDateFilterExportCSV}
                                    value={endDateFilterExportCSV ? dayjs(endDateFilterExportCSV) : null}
                                    onChange={(newValue) => {
                                        setEndDateFilterExportCSV(newValue);
                                    }}
                                    minDate={startDateFilterExportCSV || undefined}
                                />
                            </LocalizationProvider>
                        </Grid2>)}
                        {showExportDate && <Button
                        variant="contained"
                        style={{ 
                            width: '120px', 
                            height: '44px', 
                            backgroundColor: exportloading ? '#a0d8b3' : '#36C68F', 
                            textTransform: 'none', 
                            borderRadius: '8px',
                            marginLeft: "12px",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px'
                        }}
                        onClick={handleExportCSV}
                        disabled={exportloading}
                    >
                        {exportloading ? (
                            <>
                                <span style={{ color: '#fff' }}><CircularProgress size={20} style={{ color: '#fff' }} /></span>
                            </>
                        ) : (
                            <span style={{ color: '#fff' }}>Export CSV</span>
                        )}
                    </Button>}
                                    
            </Grid2>


            {(openAddModal  || openEditModal) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20,overflowY:'auto',
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleCloseModal}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto', boxShadow:'none',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {openEditModal ? 'Edit Customer' : 'Add Customer'}
                                </Typography>
    
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Label>Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Name" fullWidth variant="outlined" type="text" 
                                            value={newCustomerName}
                                            onChange={(e) => setNewCustomerName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>
        
                                    <Grid item xs={12} sm={6}>
                                        <Label>Mobile Number<span style={{ color: 'red' }}>*</span></Label>
                                        <PhoneInput
                                            defaultCountry="IN"
                                            value={newCustomerPhone} {...openEditModal ? {disabled: true} : {}}
                                            onChange={(value) => {
                                            setNewCustomerPhone(value);
                                            try {
                                                const parsed = parsePhoneNumber(value);
                                                if (parsed) {
                                                setNewCustomerCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                }
                                            } catch (err) {
                                                console.error('Invalid phone number:', err);
                                                setNewCustomerCountryCode('');
                                            }
                                            }}
                                            placeholder="Enter phone number"
                                            style={{
                                            height: '48px',
                                            border: '1px solid rgb(157, 158, 160)',
                                            fontSize: '16px', borderRadius:'8px',
                                            alignItems: 'normal', marginTop:'2%'
                                            }}
                                        />
        
                                    </Grid>
        
                                    <Grid item xs={12} sm={6}>
                                        <Label>Email ID<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Email" 
                                            fullWidth 
                                            variant="outlined" 
                                            type="email" 
                                            value={newCustomerEmail}
                                            error={emailError}
                                            helperText={emailError ? 'Please enter a valid email address' : ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setNewCustomerEmail(value);
                                                setEmailError(!validateEmail(value) && value !== '');
                                            }}
                                            InputProps={{
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>

                                    {show_user_code_for_panel==1 &&
                                        <Grid item xs={12} sm={6}>
                                            <Label>Client ID<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Client ID" fullWidth variant="outlined" type="text" 
                                                value={userCode}
                                                onChange={(e) => setUserCode(e.target.value)}
                                                InputProps={{
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid>
                                    }

                                    {clientRole==2 && 
                                        <Grid item xs={12} sm={6}>
                                            <Label>Employee ID<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Employee ID" fullWidth variant="outlined" type="text" 
                                                value={employeeId}
                                                onChange={(e) => setEmployeeId(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid>
                                    }

                                    {clientRole==2 && 
                                        <Grid item xs={12} sm={6}>
                                            <Label>Designation<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Designation" fullWidth variant="outlined" type="text" 
                                                value={designation}
                                                onChange={(e) => setDesignation(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid>
                                    }

                                    { clientRole == 2 && 
                                    <Grid item xs={12} sm={12}>
                                    <Label>Role<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField  sx={{marginTop:'1%'}}
                                        placeholder="Role" fullWidth variant="outlined" type="text" 
                                        value={corporateRole}
                                        onChange={(e) => setCorporateRole(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>

                                    }
        
                                    {(is_rizzo_client!=1 && clientRole!=2) &&
                                        <Grid item xs={12} sm={6}>
                                            <Label>Gender</Label>
                                            <Select sx={{marginTop:'2%'}}
                                                value={newCustomerGender} fullWidth
                                                onChange={(e) => setNewCustomerGender( e.target.value)}
                                                style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                <MenuItem value="">Gender</MenuItem>
                                                <MenuItem value="1">Male</MenuItem>
                                                <MenuItem value="2">Female</MenuItem>
                                                <MenuItem value="3">Others</MenuItem>
                                            </Select>
                                        </Grid>
                                    }
                                    {(is_rizzo_client!=1 && clientRole!=2) &&
                                        <Grid item xs={12} sm={6}>
                                            <Label>Date of Birth<span style={{ color: 'red' }}>*</span></Label><br/>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                value={newCustomerDob}
                                                onChange={(value) => setNewCustomerDob(value)}
                                                slotProps={{
                                                    textField: {
                                                    fullWidth: true,
                                                    sx: {
                                                        marginTop:'2%', 
                                                        height: '50px', // Outer box height
                                                        '& .MuiInputBase-root': {
                                                        height: '50px', // Internal input height
                                                        borderRadius:'8px',
                                                        },
                                                    },
                                                    }
                                                }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    }

                                    {is_rizzo_client==1 &&
                                        <Grid item xs={12} sm={12}>
                                            <Label>Company Name (Optional)</Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Company Name" 
                                                fullWidth 
                                                variant="outlined" 
                                                type="text" 
                                                value={newCustomerCompany}
                                                // error={emailError}
                                                // helperText={emailError ? 'Please enter a valid email address' : ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setNewCustomerCompany(value);
                                                }}
                                                InputProps={{
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid>
                                    }
                                    { (activation_deactivation_date_range == 1 && clientRole!=2) && 
                                        <Grid2 item sx={{marginLeft:'2%',marginTop:'2%'}} xs={12} sm={6}>
                                            <Label sx={{marginTop:'2%'}}>Activation Date:</Label><br/>
                                            <LocalizationProvider dateAdapter={AdapterDayjs} xs={{marginTop:'2%'}} >
                                                <DatePicker
                                                    slotProps={{ 
                                                        textField: { 
                                                            size: 'medium',
                                                            fullWidth:true,
                                                            error: endDateFilter && startDateFilter && startDateFilter?.isAfter(endDateFilter)
                                                        } 
                                                    }}
                                                    sx={{
                                                        width: '320px',
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#FFFFFF',
                                                            marginTop:'2%'
                                                        }
                                                    }}
                                                    value={startDateFilter}
                                                    format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}
                                                    onChange={(newValue) => {
                                                        if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                                            setEndDateFilter(null);
                                                        }
                                                        setStartDateFilter(newValue);
                                                    }}
                                                    maxDate={endDateFilter || undefined}
                                                />
                                            </LocalizationProvider>
                                        </Grid2>
                                    }

                                    { (activation_deactivation_date_range == 1 && clientRole!=2) && 
                                        <Grid2 item sx={{marginLeft:'3%',marginTop:'2%'}} xs={12} sm={6}>
                                            <Label>Deactivation Date:</Label><br/>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}
                                                    slotProps={{ 
                                                        textField: { 
                                                            size: 'small',
                                                            fullWidth:true,
                                                            error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                                        } 
                                                    }}
                                                    sx={{
                                                        width: '320px',
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#FFFFFF',
                                                            marginTop:'2%'
                                                        }
                                                    }}
                                                    value={endDateFilter}
                                                    onChange={(newValue) => setEndDateFilter(newValue)}
                                                    minDate={startDateFilter || undefined}
                                                />
                                            </LocalizationProvider>
                                        </Grid2>
                                    }
                                    
                                </Grid>
                                
                            </Paper>

                            {clientRole==2 &&
                                <Paper elevation={3}
                                    style={{ padding: '30px', maxWidth: '800px', margin: '0 auto', marginTop:'2%',
                                        backgroundColor: '#FFFFFF', borderRadius: '12px', boxShadow:'none'}}>
                                    <Typography variant="h6" style={{ color:'#4E545D', fontSize:'22px',marginBottom:'2%' }}>
                                        User Monthly Limit
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <Label>Max Ride Limit<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Max Ride Limit" fullWidth variant="outlined" type="number" 
                                                value={maxRideLimit}
                                                onChange={(e) => setMaxRideLimit(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid>
                                        {/* <Grid item xs={12} sm={6}>
                                            <Label>Max Budget Limit<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Max Budget Limit" fullWidth variant="outlined" type="number" 
                                                value={maxBudgetLimit}
                                                onChange={(e) => setMaxBudgetLimit(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid> */}
                                    </Grid>
                                </Paper>
                            }


                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'8%' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={clientRole == 2 && openEditModal ? handleEditSubmit : saveNewCustomer}
                                    sx={{width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                    Save
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleCloseModal}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#F0F0F0',
                                        color: '#B0B0B0',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
    
                        </div>
                    </Box>
                </div>
            )}
            

            <TableContainer className="table-container" style={{ maxHeight: '60vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            {/* <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header' active={orderBy === 'driver_name'} direction={orderBy === 'driver_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('driver_name')}>
                                    Name
                                </TableSortLabel>
                            </TableCell> */}
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header' active={orderBy === 'user_id'} direction={orderBy === 'user_id' ? order : 'desc'}
                                    onClick={() => handleRequestSort('user_id')} sx={{
                                        '& .MuiTableSortLabel-icon': {
                                            color: '#0065FF !important', // Change the arrow color
                                        },
                                    }}>
                                    Customer ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" >
                                {/* <TableSortLabel className='table-header' active={orderBy === 'user_name'} direction={orderBy === 'user_name' ? order : 'desc'}
                                    onClick={() => handleRequestSort('user_name')}>
                                    Customer
                                </TableSortLabel> */}
                                <Box sx={headerLabelStyle}>Customer</Box>
                            </TableCell>
                            {show_user_code_for_panel==1 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'user_code'} direction={orderBy === 'user_code' ? order : 'desc'}
                                        onClick={() => handleRequestSort('user_code')}>
                                        Client ID
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Client ID</Box>
                                </TableCell>
                            }
                            {clientRole==2 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'user_role'} direction={orderBy === 'user_role' ? order : 'desc'}
                                        onClick={() => handleRequestSort('user_role')}>
                                        Role
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Role</Box>
                                </TableCell>
                            }
                            
                            <TableCell align="center" className="table-header">
                                {/* <TableSortLabel className='table-header' active={orderBy === 'user_email'} direction={orderBy === 'user_email' ? order : 'desc'}
                                    onClick={() => handleRequestSort('user_email')}>
                                    Email
                                </TableSortLabel> */}
                                <Box sx={headerLabelStyle}>Email</Box>
                            </TableCell>

                            {clientRole==2 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'employee_id'} direction={orderBy === 'employee_id' ? order : 'desc'}
                                        onClick={() => handleRequestSort('employee_id')}>
                                        Employee ID
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Employee ID</Box>
                                </TableCell>
                            }
                            {clientRole==2 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'ride_limit'} direction={orderBy === 'ride_limit' ? order : 'desc'}
                                        onClick={() => handleRequestSort('ride_limit')}>
                                        Ride Limit
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Ride Limit</Box>
                                </TableCell>
                            }
                            {clientRole!=2 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'email_verification_status'} direction={orderBy === 'email_verification_status' ? order : 'desc'}
                                        onClick={() => handleRequestSort('email_verification_status')}>
                                    Email Verification Status
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Email Verification Status</Box>
                                </TableCell>
                            }
                            {/* <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Phone No.</TableSortLabel>
                            </TableCell> */}
                            
                            {(is_rizzo_client!=1 && clientRole!=2) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'gender'} direction={orderBy === 'gender' ? order : 'desc'}
                                        onClick={() => handleRequestSort('gender')}>
                                        Gender
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Gender</Box>
                                </TableCell>
                            }
                            {(is_rizzo_client!=1 && clientRole!=2) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'date_of_birth'} direction={orderBy === 'date_of_birth' ? order : 'desc'}
                                        onClick={() => handleRequestSort('date_of_birth')}>
                                        Date Of Birth
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Date Of Birth</Box>
                                </TableCell>
                            }
                            {(is_rizzo_client==1 && clientRole!=2) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'company_name'} direction={orderBy === 'company_name' ? order : 'desc'}
                                        onClick={() => handleRequestSort('company_name')}>
                                        Company Name
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Company Name</Box>
                                </TableCell>
                            }
                            {clientRole!=2 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'city'} direction={orderBy === 'city' ? order : 'desc'}
                                        onClick={() => handleRequestSort('city')}>
                                        City
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>City</Box>
                                </TableCell> 
                            }
                            {clientRole!=2 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'registered_city'} direction={orderBy === 'registered_city' ? order : 'desc'}
                                        onClick={() => handleRequestSort('registered_city')}>
                                        Registered City
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Registered City</Box>
                                </TableCell>
                            }
                            {(clientRole!=2 && clientId!=188) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'current_latitude'} direction={orderBy === 'current_latitude' ? order : 'desc'}
                                        onClick={() => handleRequestSort('current_latitude')}>
                                        Current Latitude
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Current Latitude</Box>
                                </TableCell>
                            }
                            {(clientRole!=2 && clientId!=188) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'current_longitude'} direction={orderBy === 'current_longitude' ? order : 'desc'}
                                        onClick={() => handleRequestSort('current_longitude')}>
                                        Current Longitude
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Current Longitude</Box>
                                </TableCell>
                            }
                            {(clientRole!=2 && clientId!=188) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'registered_latitude'} direction={orderBy === 'registered_latitude' ? order : 'desc'}
                                        onClick={() => handleRequestSort('registered_latitude')}>
                                        Registered Latitude
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Registered Latitude</Box>
                                </TableCell>
                            }
                            {(clientRole!=2 && clientId!=188) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'registered_longitude'} direction={orderBy === 'registered_longitude' ? order : 'desc'}
                                        onClick={() => handleRequestSort('registered_longitude')}>
                                        Registered Longitude
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Registered Longitude</Box>
                                </TableCell>
                            }
                            {clientRole!=2 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'total_trips'} direction={orderBy === 'total_trips' ? order : 'desc'}
                                        onClick={() => handleRequestSort('total_trips')} sx={{
                                            '& .MuiTableSortLabel-icon': {
                                                color: '#0065FF !important', // Change the arrow color
                                            },
                                        }}>
                                        Total Trips
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Total Trips</Box>
                                </TableCell>
                            }
                            {(clientDemoType!=2 && clientRole!=2) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'rating'} direction={orderBy === 'rating' ? order : 'desc'}
                                        onClick={() => handleRequestSort('rating')} sx={{
                                            '& .MuiTableSortLabel-icon': {
                                                color: '#0065FF !important', // Change the arrow color
                                            },
                                        }}>
                                        Rating
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Rating</Box>
                                </TableCell>
                            }
                            {(clientRole!=2 && clientId!=188) &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'wallet_balance'} direction={orderBy === 'wallet_balance' ? order : 'desc'}
                                        onClick={() => handleRequestSort('wallet_balance')}>
                                        User Wallet Balance
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>User Wallet Balance</Box>
                                </TableCell>
                            }
                            {clientRole!=2 &&
                                <TableCell align="center" className="table-header" >
                                    <Box sx={headerLabelStyle}> Device Type</Box>
                                </TableCell>
                            }
                            {clientRole!=2 &&
                                <TableCell align="center" className="table-header" >
                                    <Box sx={headerLabelStyle}> 
                                        App Version Code
                                    </Box>
                                </TableCell>
                            }
                            {clientRole!=2 &&
                                <TableCell align="center" className="table-header" >
                                    <Box sx={headerLabelStyle}> OTP</Box>
                                </TableCell>
                            }
                            {(clientRole!=2) && hasPermission2 &&
                                <TableCell align="center" className="table-header">
                                    <Box sx={headerLabelStyle}> Action</Box>
                                </TableCell>
                            }
                            {hasPermission2 && <TableCell align="center" className="table-header">
                                {/* <TableSortLabel className="table-header">
                                Deactivate / Delete
                                </TableSortLabel> */}
                                <Box sx={headerLabelStyle}>Deactivate / Delete</Box>
                            </TableCell>}
                            {clientRole==2 &&
                                <TableCell align="center" className="table-header">
                                    {/* <TableSortLabel className='table-header' active={orderBy === 'ride_limit'} direction={orderBy === 'ride_limit' ? order : 'desc'}
                                        onClick={() => handleRequestSort('ride_limit')}>
                                        Action
                                    </TableSortLabel> */}
                                    <Box sx={headerLabelStyle}>Action</Box>
                                </TableCell>
                            }
                            {hasPermission(SidebarTabs.CHAT) && (
                                <TableCell align="center" className="table-header">
                                    Chat
                            </TableCell>
                            )}
                            {(panel_customer_specific_address==1 && clientRole!=2) && 
                                <TableCell align="center" className="table-header">
                                    Address
                                </TableCell>
                            }

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedData.map((row) => {
                            // Find the city name for city_id
                            const city = clientCities.find(city => city.city_id === row.city_id);
                            const cityName = city ? city.city_name : '---';

                            // Find the city name for registered_city_id
                            const registeredCity = clientCities.find(city => city.city_id === row.registered_city_id);
                            const registeredCityName = registeredCity ? registeredCity.city_name : '---';

                            return (
                                <TableRow key={row.id}>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px', pr: '28px' }}>
                                            {row.user_id}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Grid2 container sx={{ width: 'auto', minWidth: '180px' }}>
                                            <Grid2>
                                                <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt={row.user_name} src={row.user_image} />
                                            </Grid2>
                                            <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                                                <Grid2>
                                                    <Typography>{row.user_name}</Typography>
                                                </Grid2>
                                                <Grid2>
                                                    <Typography sx={{ color: '#83888E', fontSize: '12px' }}>
                                                        {clientdataShown == 0 ? row.phone_number : (() => {
                                                            if (!row.phone_number) return '****';
                                                            const phone = row.phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}
                                                    </Typography>
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>
                                    </TableCell>
                                    {clientRole==2 &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left' }}>{row.corporate_role ? row.corporate_role : '---'}</Typography>
                                        </TableCell>
                                    }
                                    {show_user_code_for_panel==1 &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px' }}>
                                                {row.user_code ? row.user_code : '--'}
                                            </Typography>
                                        </TableCell>
                                    }
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'left' }}>
                                            {clientdataShown == 0 ? row.user_email : (() => {
                                                if (!row.user_email) return '****';
                                                const email = row.user_email;
                                                const atIndex = email.indexOf('@');
                                                if (atIndex <= 2) return '**' + email.substring(atIndex);
                                                const firstTwo = email.substring(0, 2);
                                                const domain = email.substring(atIndex);
                                                const maskedMiddle = '*'.repeat(atIndex - 2);
                                                return firstTwo + maskedMiddle + domain;
                                            })()}
                                        </Typography>
                                    </TableCell>
                                    {clientRole==2 &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left' }}>{row.corporate_emp_id ? row.corporate_emp_id : '---'}</Typography>
                                        </TableCell>
                                    }
                                    {clientRole==2 &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left' }}>{row.corporate_ride_limit}</Typography>
                                        </TableCell>
                                    }
                                    {clientRole!=2 &&
                                        <TableCell>{row.email_verification_status ==1 ? 'Verified' : 'Not Verified'}</TableCell>
                                    }
                                    {(is_rizzo_client!=1 && clientRole!=2) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '120px' }}>
                                                {row.gender === 1 ? 'Male' : row.gender === 2 ? 'Female' : row.gender === 3 ? 'Others' : "---"}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(is_rizzo_client!=1 && clientRole!=2) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '120px' }}>
                                                {(row.date_of_birth)?.split('T')[0]}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(is_rizzo_client==1 && clientRole!=2) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '120px' }}>
                                                {row.company_name ? row.company_name : '--'}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(clientRole!=2) &&
                                        <TableCell>{cityName}</TableCell>
                                    }
                                    {(clientRole!=2) &&
                                        <TableCell>{registeredCityName}</TableCell>
                                    }
                                    {(clientRole!=2 && clientId!=188) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '100px' }}>
                                                {row.current_latitude}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(clientRole!=2 && clientId!=188) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '100px' }}>
                                                {row.current_longitude}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(clientRole!=2 && clientId!=188) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '100px' }}>
                                                {row.registered_latitude}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(clientRole!=2 && clientId!=188) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '100px' }}>
                                                {row.registered_longitude}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(clientRole!=2) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px', marginRight: '12px' }}>
                                                {row.total_trips}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(clientDemoType!=2 && clientRole!=2) &&
                                        <TableCell sx={{ textAlign: 'left' }}>
                                            {parseFloat(row.rating).toFixed(2)} 
                                            <img src={starIcon} height="12px" width="12px" style={{ marginLeft: '1%' }} />
                                        </TableCell>
                                    }
                                    {(clientRole!=2 && clientId!=188) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px' }}>
                                                {row.user_wallet_balance}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(clientRole!=2) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px', color:row.device_type==0 ? '#0065ff' : row.device_type==1 ? 'green' : 'red' }}>
                                                {row.device_type==0 ? 'Android' : row.device_type==1 ? 'iOS' : '--'}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {(clientRole!=2) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px' }}>
                                                {row.app_version_code}
                                            </Typography>
                                        </TableCell>
                                    }
                                    
                                    {(clientRole!=2) &&
                                        <TableCell>
                                            <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px' }}>
                                                {row.login_otp ? row.login_otp : '--'}
                                            </Typography>
                                        </TableCell>
                                    }
                                    {/* <TableCell align="center">

                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpen(row)}
                                            sx={{
                                                backgroundColor: 'white',
                                                color: 'black',
                                                border: '1px solid black',
                                                textTransform: 'none',
                                                borderRadius: '8px', 
                                                width: 'auto', // Or set a specific width
                                                minWidth: '120px', 
                                                '&:hover': {
                                                    backgroundColor: 'black',
                                                    color: 'white',
                                                },
                                                '&:active': {
                                                    backgroundColor: 'black',
                                                    color: 'white',
                                                },
                                            }}
                                        >
                                            Credit/Debit
                                        </Button>
                                    </TableCell>    */}
                                    {(clientRole!=2) && hasPermission2 &&
                                        <TableCell align="center">
                                            <Button
                                                variant="contained"
                                                onClick={() => viewData(row)}
                                                sx={{
                                                    backgroundColor: "white",
                                                    color: "black",
                                                    border: "1px solid black",
                                                    textTransform: "none",
                                                    borderRadius: "8px",
                                                    width: "auto", // Or set a specific width
                                                    minWidth: "120px",
                                                    marginBottom: "10px",
                                                    "&:hover": {
                                                    backgroundColor: "black",
                                                    color: "white",
                                                    },
                                                    "&:active": {
                                                    backgroundColor: "black",
                                                    color: "white",
                                                    },
                                                }}
                                                >
                                                View Details
                                            </Button>
                                            {clientRole!=2 && clientId!=188 && hasPermission4 &&
                                                <Button
                                                    variant="contained"
                                                    onClick={() => handleOpen(row)}
                                                    sx={{
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        border: '1px solid black',
                                                        textTransform: 'none',
                                                        borderRadius: '8px', 
                                                        width: 'auto', // Or set a specific width
                                                        minWidth: '120px', 
                                                        marginBottom: "10px",
                                                        '&:hover': {
                                                            backgroundColor: 'black',
                                                            color: 'white',
                                                        },
                                                        '&:active': {
                                                            backgroundColor: 'black',
                                                            color: 'white',
                                                        },
                                                    }}
                                                >
                                                    Credit/Debit
                                                </Button>
                                            }
                                            {(clientRole!=2) &&  hasPermission2 && 
                                                <Button
                                                    variant="contained"
                                                    onClick={() => handleEditOpen(row)}
                                                    sx={{
                                                        backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                        borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"120px",
                                                        '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                        '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                            }
                                        </TableCell> 
                                    }
                                      
                                    {hasPermission2 &&<TableCell align="center">
                                        {row.deactivation_status !== 1 && row.deactivation_status !== 0 && 
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenDeactivateModal(row, 'activate')}
                                            sx={{
                                            backgroundColor: "white",
                                            color: "black",
                                            border: "1px solid black",
                                            textTransform: "none",
                                            borderRadius: "8px",
                                            width: "auto", // Or set a specific width
                                            minWidth: "120px",
                                            marginBottom: "10px",
                                            "&:hover": {
                                                backgroundColor: "black",
                                                color: "white",
                                            },
                                            "&:active": {
                                                backgroundColor: "black",
                                                color: "white",
                                            },
                                            }}
                                        >
                                            Activate
                                        </Button> 
                                        }
                    
                                        {row.deactivation_status !== 2 && 
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenDeactivateModal(row, 'deactivate')}
                                            sx={{
                                            backgroundColor: "white",
                                            color: "black",
                                            border: "1px solid black",
                                            textTransform: "none",
                                            borderRadius: "8px",
                                            width: "auto", // Or set a specific width
                                            minWidth: "120px",
                                            marginBottom: "10px",
                                            "&:hover": {
                                                backgroundColor: "black",
                                                color: "white",
                                            },
                                            "&:active": {
                                                backgroundColor: "black",
                                                color: "white",
                                            },
                                            }}
                                        >
                                            Deactivate
                                        </Button> 
                                        }
                    
                                        {clientRole!=2 &&
                                            <Button
                                                variant="contained"
                                                onClick={() => handleOpenDeactivateModal(row, 'delete')}
                                                sx={{
                                                backgroundColor: "white",
                                                color: "black",
                                                border: "1px solid black",
                                                textTransform: "none",
                                                borderRadius: "8px",
                                                width: "auto", // Or set a specific width
                                                minWidth: "120px",
                                                "&:hover": {
                                                    backgroundColor: "black",
                                                    color: "white",
                                                },
                                                "&:active": {
                                                    backgroundColor: "black",
                                                    color: "white",
                                                },
                                                }}
                                            >
                                                Delete
                                            </Button>
                                        }
                                    </TableCell>}
                                    {(clientRole==2) && 
                                                <Button
                                                    variant="contained"
                                                    onClick={() => handleOpenEdit(row)}
                                                    sx={{
                                                        backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                        borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"120px",marginTop:'12%',height:'40px',marginRight:'12px',
                                                        '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                        '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                            }
                                {hasPermission(SidebarTabs.CHAT) && (
                                   <TableCell align="center">
                                        <Button
                                                variant="contained"
                                                onClick={() => chatClick(row)}
                                                sx={{
                                                    backgroundColor: "white",
                                                    color: "black",
                                                    border: "1px solid black",
                                                    textTransform: "none",
                                                    borderRadius: "8px",
                                                    width: "auto",
                                                    minWidth: "120px",
                                                    marginBottom: "10px",
                                                    "&:hover": {
                                                    backgroundColor: "#36c68f",
                                                    border: "1px solid #36c68f",
                                                    color: "white",
                                                    },
                                                    "&:active": {
                                                    backgroundColor: "black",
                                                    color: "white",
                                                    },
                                                }}
                                                >
                                                Initiate Chat
                                            </Button>
                                    </TableCell>)}
                                    {(panel_customer_specific_address==1 && clientRole!=2) && 
                                        <TableCell align="center">
                                            <Button onClick={() => navigate(`/address`, { state: { rowData: row } })}>
                                                View
                                            </Button>
                                        </TableCell>
                                    }
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>

                {/* Dialog */}
                <Dialog
                    open={open}
                    onClose={handleClose}
                    sx={{
                        '& .MuiDialog-paper': {
                            width: '50%',
                            maxWidth: 'none',
                        },
                    }}
                >
                    <DialogTitle
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                        }}
                    >
                        User Wallet Transactions
                    </DialogTitle>
                    <DialogContent>
                        <Box display="flex" alignItems="center" mb={2}>
                            <Box width="30%" fontWeight="bold">
                                Type:
                            </Box>
                            <FormControl fullWidth>
                                <Select
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Type' }}
                                >
                                    <MenuItem value="credit">Credit</MenuItem>
                                    <MenuItem value="debit">Debit</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Box display="flex" alignItems="center" mb={2}>
                            <Box width="30%" fontWeight="bold">
                                Amount:
                            </Box>
                            <TextField
                                fullWidth
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="Enter Amount"
                            />
                        </Box>

                        <Box display="flex" alignItems="center" mb={2}>
                            <Box width="30%" fontWeight="bold">
                                Reason:
                            </Box>
                            <TextField
                                fullWidth
                                type="string"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Enter Reason"
                            />
                        </Box>
                    </DialogContent>

                    <Box display="flex" justifyContent="center" gap={2} mt={3} mb={2}>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            sx={{ width: '150px' }}
                            disabled={!amount || !reason || txnLoading} // Disable if amount or reason is empty
                        >
                            {txnLoading ? 'Processing...' : (type === 'credit' ? 'Credit' : 'Debit')}
                        </Button>
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            Cancel
                        </Button>
                    </Box>
                </Dialog>

                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            paginationInfo.total
                        )} of ${paginationInfo.total} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {page > 1 && (
                                <>
                                    <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                        1
                                    </button>
                                    <span className="pagination-dots">...</span>
                                </>
                            )}
                            {[...Array(totalPages)]
                                .map((_, index) => index)
                                .filter((index) => index >= page - 1 && index <= page + 1)
                                .map((index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleChangePage(null, index)}
                                        className={`pagination-number ${page === index ? 'active' : ''}`}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                            {page < totalPages - 2 && (
                                <>
                                    <span className="pagination-dots">...</span>
                                    <button
                                        onClick={() => handleChangePage(null, totalPages - 1)}
                                        className="pagination-number"
                                    >
                                        {totalPages}
                                    </button>
                                </>
                            )}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= totalPages - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Dialog
                open={openDeactivateModal}
                onClose={handleCloseDeactivateModal}
                PaperProps={{
                style: {
                    borderRadius: '12px',
                    padding: '8px',
                    maxWidth: '500px'
                }
                }}
            >
            <DialogTitle>
              <Typography variant="h6" fontWeight="600">
                {actionType === 'activate' ? 'Activate' : 
                  actionType === 'deactivate' ? 'Deactivate' : 'Delete'} Customer
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCloseDeactivateModal}
                sx={{
                  position: 'absolute',
                  right: 12,
                  top: 12,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1" sx={{ my: 2 }}>
                Are you sure you want to {actionType === 'activate' ? 'activate' : 
                  actionType === 'deactivate' ? 'deactivate' : 'delete'} this customer ?
              </Typography>
              
              <TextField
                autoFocus
                margin="dense"
                id="reason"
                label="Reason"
                type="text"
                fullWidth
                variant="outlined"
                value={deactivateReason}
                onChange={handleReasonChange}
                error={reasonError}
                helperText={reasonError ? "Reason is required" : ""}
                sx={{ mt: 2, mb: 3 }}
              />
              
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  onClick={handleCloseDeactivateModal} 
                  sx={{ mr: 2, textTransform: 'none' }}
                >
                  Cancel
                </Button>
                <Button sx={{textTransform: 'none'}}
                  onClick={handleConfirmDeactivate} 
                  variant="contained" 
                  color={actionType === 'delete' ? 'error' : 
                        actionType === 'deactivate' ? 'warning' : 'primary'}
                >
                  {actionType === 'activate' ? 'Activate' : 
                    actionType === 'deactivate' ? 'Deactivate' : 'Delete'}
                </Button>
              </Box>
            </DialogContent>
          </Dialog>

            {/* <Dialog
                        open={editOpen}
                        onClose={handleEditClose}
                        sx={{
                            '& .MuiDialog-paper': {
                            width: '100%',
                            maxWidth: 400,
                            borderRadius: '12px',
                            padding: '24px',
                            },
                        }}
                        >
                        <DialogTitle
                            sx={{
                            textAlign: 'center',
                            fontSize: '1.2rem',
                            pb: 0,
                            }}
                        >
                            Update Details
                        </DialogTitle>

                        <DialogContent sx={{ mt: 2 }}>
                            <Grid2 container spacing={2}>
                            <Grid2 item xs={12}>
                                <Label style={{color:'#83888E',}}>Activation Date</Label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: 'medium',
                                        // error:
                                        // endDateFilter &&
                                        // startDateFilter &&
                                        // startDateFilter?.isAfter(endDateFilter),
                                    },
                                    }}
                                    sx={{
                                    width: '350px',
                                    mt: 1,
                                    '& .MuiInputBase-root': {
                                        height: '50px',
                                        borderRadius: '10px',
                                        backgroundColor: '#FFFFFF',
                                    },
                                    }}
                                    value={startDateFilter}
                                    format={date_format_dd_mm_yy ? 'DD-MM-YYYY' : 'YYYY-MM-DD'}
                                    onChange={(newValue) => {
                                    if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                        setEndDateFilter(null);
                                    }
                                    setStartDateFilter(newValue);
                                    }}
                                    maxDate={endDateFilter || undefined}
                                />
                                </LocalizationProvider>
                            </Grid2>

                            <Grid2 item xs={12}>
                                <Label style={{color:'#83888E',}}>Deactivation Date</Label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    format={date_format_dd_mm_yy ? 'DD-MM-YYYY' : 'YYYY-MM-DD'}
                                    slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: 'medium',
                                        // error:
                                        // endDateFilter &&
                                        // startDateFilter &&
                                        // startDateFilter.isAfter(endDateFilter),
                                    },
                                    }}
                                    sx={{
                                    mt: 1,
                                    '& .MuiInputBase-root': {
                                        height: '50px',
                                        borderRadius: '10px',
                                        backgroundColor: '#FFFFFF',
                                    },
                                    }}
                                    value={endDateFilter}
                                    onChange={(newValue) => setEndDateFilter(newValue)}
                                    minDate={startDateFilter || undefined}
                                />
                                </LocalizationProvider>
                            </Grid2>
                            </Grid2>
                        </DialogContent>

                        <Box display="flex" justifyContent="center" gap={2} mt={3} mb={1}>
                            <Button
                            onClick={handleEditSubmit}
                            variant="contained"
                            sx={{
                                width: '130px',
                                height: '45px',
                                backgroundColor: '#007BFF',
                                fontWeight: 'bold',
                                borderRadius: '10px',
                                '&:hover': {
                                backgroundColor: '#006AE0',
                                },
                            }}
                            >
                            Update
                            </Button>
                            <Button
                            onClick={handleEditClose}
                            variant="outlined"
                            sx={{
                                width: '130px',
                                height: '45px',
                                fontWeight: 'bold',
                                borderRadius: '10px',
                                color: '#007BFF',
                                borderColor: '#007BFF',
                                '&:hover': {
                                backgroundColor: '#F0F8FF',
                                borderColor: '#006AE0',
                                },
                            }}
                            >
                            Cancel
                            </Button>
                        </Box>
                </Dialog> */}

            {editOpen && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20,overflowY:'auto',
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleEditClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto', boxShadow:'none',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    Edit Details
                                </Typography>
    
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Label>Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'1%'}}
                                            placeholder="Name" fullWidth variant="outlined" type="text" 
                                            value={customerEditName}
                                            onChange={(e) => setCustomerEditName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>
        
                                    <Grid item xs={12} sm={6}>
                                        <Label>Email ID<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Email" 
                                            fullWidth 
                                            variant="outlined" 
                                            type="email" 
                                            value={customerEditEmail}
                                            error={emailError}
                                            helperText={emailError ? 'Please enter a valid email address' : ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setCustomerEditEmail(value);
                                                setEmailError(!validateEmail(value) && value !== '');
                                            }}
                                            InputProps={{
                                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Mobile Number<span style={{ color: 'red' }}>*</span></Label>
                                        <PhoneInput
                                            defaultCountry="IN"
                                            value={customerEditPhone} {...openEditModal ? {disabled: true} : {}}
                                            onChange={(value) => {
                                            setCustomerEditPhone(value);
                                            try {
                                                const parsed = parsePhoneNumber(value);
                                                if (parsed) {
                                                setCustomerEditCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                }
                                            } catch (err) {
                                                console.error('Invalid phone number:', err);
                                                setCustomerEditCountryCode('');
                                            }
                                            }}
                                            placeholder="Enter phone number"
                                            style={{
                                                width:'100%',
                                            height: '48px',
                                            border: '1px solid rgb(157, 158, 160)',
                                            fontSize: '16px', borderRadius:'8px',
                                            alignItems: 'normal', marginTop:'2%'
                                            }}
                                        />
        
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label>Gender</Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={customerEditGender} fullWidth
                                            onChange={(e) => setCustomerEditGender( e.target.value)}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                            <MenuItem value="">Gender</MenuItem>
                                            <MenuItem value="1">Male</MenuItem>
                                            <MenuItem value="2">Female</MenuItem>
                                            <MenuItem value="3">Others</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Label>Date of Birth</Label><br/>
                                            <LocalizationProvider dateAdapter={AdapterDayjs} xs={{marginTop:'2%'}} >
                                                <DatePicker
                                                    slotProps={{ 
                                                        textField: { 
                                                            size: 'medium',
                                                            fullWidth:true
                                                        } 
                                                    }}
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#FFFFFF',
                                                            marginTop:'2%'
                                                        }
                                                    }}
                                                    value={customerEditDob}
                                                    format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}
                                                    onChange={(newValue) => {
                                                        setCustomerEditDob(newValue);
                                                    }}
                                                    maxDate={dayjs()}
                                                />
                                            </LocalizationProvider>
                                    </Grid>

                                    {show_user_code_for_panel==1 &&
                                        <Grid item xs={12} sm={6}>
                                            <Label>Client ID<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Client ID" fullWidth variant="outlined" type="text" 
                                                value={customerEditUserCode}
                                                onChange={(e) => setCustomerEditUserCode(e.target.value)}
                                                InputProps={{
                                                    style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                                }}
                                            />
                                        </Grid>
                                    }

                                    { (activation_deactivation_date_range == 1 && clientRole!=2) && 
                                        <Grid item xs={12} sm={6}>
                                            <Label>Activation Date:</Label><br/>
                                            <LocalizationProvider dateAdapter={AdapterDayjs} xs={{marginTop:'2%'}} >
                                                <DatePicker
                                                    slotProps={{ 
                                                        textField: { 
                                                            size: 'medium',
                                                            fullWidth:true,
                                                            error: endDateFilter && startDateFilter && startDateFilter?.isAfter(endDateFilter)
                                                        } 
                                                    }} fullWidth
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#FFFFFF',
                                                            marginTop:'2%'
                                                        }
                                                    }}
                                                    value={startDateFilter}
                                                    format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}
                                                    onChange={(newValue) => {
                                                        if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                                            setEndDateFilter(null);
                                                        }
                                                        setStartDateFilter(newValue);
                                                    }}
                                                    maxDate={endDateFilter || undefined}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    }

                                    { (activation_deactivation_date_range == 1 && clientRole!=2) && 
                                        <Grid item xs={12} sm={6}>
                                            <Label>Deactivation Date:</Label><br/>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format={date_format_dd_mm_yy ? "DD-MM-YYYY" : "YYYY-MM-DD"}
                                                    slotProps={{ 
                                                        textField: { 
                                                            size: 'small',
                                                            fullWidth:true,
                                                            error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                                        } 
                                                    }} fullWidth
                                                    sx={{
                                                        '& .MuiInputBase-root': {
                                                            height: '50px',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#FFFFFF',
                                                            marginTop:'2%'
                                                        }
                                                    }}
                                                    value={endDateFilter}
                                                    onChange={(newValue) => setEndDateFilter(newValue)}
                                                    minDate={startDateFilter || undefined}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                    }
                                    
                                </Grid>
                                
                            </Paper>

                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'8%' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleEditSubmit}
                                    sx={{width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                    Save
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleEditClose}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#F0F0F0',
                                        color: '#B0B0B0',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
    
                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                
        </div>
        
    )
};

export default Dashboard;